import { render, staticRenderFns } from "./addCreneaux.vue?vue&type=template&id=6567ddf2&scoped=true"
import script from "./addCreneaux.vue?vue&type=script&lang=js"
export * from "./addCreneaux.vue?vue&type=script&lang=js"
import style0 from "./addCreneaux.vue?vue&type=style&index=0&id=6567ddf2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6567ddf2",
  null
  
)

export default component.exports